import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation,
} from '@angular/core';

@Component({
  selector: 'app-power-reviews-snippet',
  templateUrl: './power-reviews-snippet.component.html',
  styleUrls: ['./power-reviews-snippet.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class PowerReviewsSnippetComponent {
  @Input() productNumber: number;
  @Output() trackRatingandReview: EventEmitter<void> = new EventEmitter<void>();

  constructor() {}

  scrollToRnR() {
    this.trackRatingandReview.emit();
    var el = document.getElementById(
      'pwr-product-details-reviews-' + this.productNumber,
    );
    el?.scrollIntoView({ behavior: 'smooth' });
  }
}
